"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _HomeownersBanner = require("./HomeownersBanner");
Object.keys(_HomeownersBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HomeownersBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _HomeownersBanner[key];
    }
  });
});